import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPendingSelector } from 'modules/api/selectors';
import MarketingChannelsView from '../views/MarketingChannelsView';
import { getMarketingChannelDataRequest, getMarketingChannelSourcesRequest } from '../actions';
import { getMarketingChannelData } from '../selectors';
import {
  DASHBOARD_MARKETING_CHANNEL_HEADER_FORM,
  MARKETING_DATA_EXPORT_MODAL,
  INITIAL_MARKETING_CHANNELS_FILTERS_VALUES,
} from '../constants';
import { store } from 'components/App';
import saga from '../sagas/marketingChannels';
import { mapMarketingChannelsParamsToRequestPayload } from '../utils/mappers';
import { openModal } from 'components/TP-UI/TPModal/actions';
import ExportMarketingChannelsModal from './ExportMarketingDataModalContainer';
import TPLoader from 'components/TP-UI/TPLoader';
import NoDataAvailable from 'modules/common/NoDataAvailable';
import { hasOnlyEmptyValues } from 'utils/hasOnlyEmptyValues';

const MarketingChannelsContainer = () => {
  const dispatch = useDispatch();
  const pending = useSelector(createPendingSelector(getMarketingChannelDataRequest));
  const marketingChannelData = useSelector(getMarketingChannelData);
  const displayedItems = useMemo(
    () => (marketingChannelData || []).filter(({ data }) => data !== ''),
    [marketingChannelData],
  );
  const [filterApplied, setFilterApplied] = useState(
    !hasOnlyEmptyValues(INITIAL_MARKETING_CHANNELS_FILTERS_VALUES),
  );

  useEffect(() => {
    store.injectSaga('MarketingChannelsSaga', saga);

    return () => {
      store.injectSaga('MarketingChannelsSaga', null);
    };
  }, []);

  useEffect(() => {
    dispatch(
      getMarketingChannelDataRequest(
        mapMarketingChannelsParamsToRequestPayload(INITIAL_MARKETING_CHANNELS_FILTERS_VALUES),
      ),
    );
    dispatch(getMarketingChannelSourcesRequest());
  }, [dispatch]);

  const handleChange = useCallback(
    (data) => {
      setFilterApplied(!hasOnlyEmptyValues(data));
      dispatch(getMarketingChannelDataRequest(mapMarketingChannelsParamsToRequestPayload(data)));
    },
    [dispatch],
  );

  const handleExport = useCallback(() => {
    dispatch(openModal(MARKETING_DATA_EXPORT_MODAL));
  }, [dispatch]);

  return !marketingChannelData ? (
    <TPLoader />
  ) : marketingChannelData.length === 0 && !filterApplied && !pending ? (
    <NoDataAvailable />
  ) : (
    <>
      <MarketingChannelsView
        form={DASHBOARD_MARKETING_CHANNEL_HEADER_FORM}
        loading={pending}
        items={displayedItems}
        onChange={handleChange}
        onExport={handleExport}
      />
      <ExportMarketingChannelsModal modalName={MARKETING_DATA_EXPORT_MODAL} />
    </>
  );
};

export default MarketingChannelsContainer;
